import React, { useContext, useEffect } from 'react';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { RedirectContext, XLRStartSequenceState } from 'src/xlr-configuration/xlr-startup';

const SHOW_LOGIN_SCREEN = 'show-login-screen';

export const showLoginScreen = () => {
  pushEmeraldModal(<ShowLoginScreen />, undefined, SHOW_LOGIN_SCREEN);
};

export const ShowLoginScreen: React.FC = () => {
  const { setStartupState } = useContext(RedirectContext);

  useEffect(() => {
    setStartupState(XLRStartSequenceState.Login);
    popEmeraldModal(SHOW_LOGIN_SCREEN);
  }, [setStartupState]);

  return <React.Fragment />;
};
